import { PROFILE_SUCCESS } from 'actionTypes';
import api from 'api';
import errors from '../lib/errors';

export default (uid, dispatch) => {
  api
    .get('/profiles/:id', {
      params: { id: uid },
    })
    .then(response => {
      dispatch({ type: PROFILE_SUCCESS, payload: { ...response.data, fullProfile: true } });
    })
    .catch(error => {
      const message = errors.clean(error);
      console.log('Silently ignoring profile fetch error', message);
    });
};
